import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { Avatar } from "@whoosh/design-system/src/components/display";
import {
  Box,
  HStack,
  Text,
} from "@whoosh/design-system/src/components/primitive";

import { NewEventDetailAttendeesListItemFragment$key } from "./__generated__/NewEventDetailAttendeesListItemFragment.graphql";

type NewEventDetailAttendeesListItemProps = {
  fragmentRef: NewEventDetailAttendeesListItemFragment$key | null;
  playerNounOverride?: string;
};

export const NewEventDetailAttendeesListItem = ({
  fragmentRef,
  playerNounOverride,
}: NewEventDetailAttendeesListItemProps) => {
  const data = useFragment(
    NewEventDetailAttendeesListItemFragmentString,
    fragmentRef
  );

  const registration = data?.registrations?.edges?.[0]?.node?.registrant;

  const name =
    registration?.firstName && registration?.lastName
      ? `${registration?.firstName} ${registration?.lastName}`
      : t`Unknown ${playerNounOverride ?? "Player"}`;

  return (
    <HStack alignItems="center" gap={4}>
      <Box width={40} height={40} overflow="hidden" style={{ borderRadius: 4 }}>
        <Avatar
          size="sm"
          profileImagePublicId={registration?.profileImage?.publicId}
          firstName={registration?.firstName}
          lastName={registration?.lastName}
          type="member"
        />
      </Box>
      <Text variant="mainBaseMedium">{name}</Text>
    </HStack>
  );
};

export const NewEventDetailAttendeesListItemFragmentString = graphql`
  fragment NewEventDetailAttendeesListItemFragment on EventSignUp {
    id
    registrations {
      edges {
        node {
          id
          type
          registrant {
            id
            firstName
            lastName
            profileImage {
              # TODO(ENG-3436): Remove the publicId alias when legacy image props are retired.
              publicId: renderingKey
            }
          }
        }
      }
    }
  }
`;
